// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   Plus, Folder, Users, X, Layers, ChevronRight,
//   Trash2, AlertTriangle, Search, Zap, ArrowRight
// } from 'lucide-react';
// import { Formik, Form, Field } from 'formik';
// import * as Yup from 'yup';
// import { authAPI, projectsAPI } from '../../services/api';
// import Button from '../../components/ui/Button';
// import SEO from '../../components/shared/SEO';
// import { useAuth } from '../../context/AuthContext';

// // --- Reusable Modal Component ---
// const Modal = ({ isOpen, onClose, title, children, variant = 'default' }) => (
//   <AnimatePresence>
//     {isOpen && (
//       <>
//         <motion.div
//           initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
//           onClick={onClose} className="fixed inset-0 bg-black/90 backdrop-blur-md z-[100]"
//         />
//         <motion.div
//           initial={{ opacity: 0, scale: 0.95, y: 40 }}
//           animate={{ opacity: 1, scale: 1, y: 0 }}
//           exit={{ opacity: 0, scale: 0.95, y: 40 }}
//           className={`fixed w-full top-[20%] left-0 right-0 mx-auto max-w-lg bg-[#0a0a0a] border rounded-[2.5rem] shadow-2xl z-[101] overflow-hidden ${variant === 'danger' ? 'border-red-500/30' : 'border-white/10'
//             }`}
//         >
//           <div className="flex justify-between items-center p-8 border-b border-white/5">
//             <h3 className={`font-black text-2xl tracking-tighter ${variant === 'danger' ? 'text-red-500' : 'text-white'}`}>
//               {title}
//             </h3>
//             <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors p-2 hover:bg-white/5 rounded-full">
//               <X size={20} />
//             </button>
//           </div>
//           <div className="p-10">{children}</div>
//         </motion.div>
//       </>
//     )}
//   </AnimatePresence>
// );

// export default function Projects() {
//   const [isCreateOpen, setCreateOpen] = useState(false);
//   const [projectToDelete, setProjectToDelete] = useState(null);
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const { user, setUser, usage, setUsage } = useAuth()
//   const navigate = useNavigate()

//   // New State for Search
//   const [searchQuery, setSearchQuery] = useState('');

//   const fetchUsage = async () => {
//     const data = await authAPI.usage();
//     if (data) setUsage(data)
//   };

//   const fetchUser = async () => {
//     const data = await authAPI.getMe();
//     if (data) {
//       setUser(data)
//     }
//   };

//   const fetchProjects = async () => {
//     try {
//       const data = await projectsAPI.getAll();
//       setProjects(data);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDelete = async () => {
//     if (!projectToDelete) return;
//     try {
//       await projectsAPI.deleteProject(projectToDelete._id);
//       setProjects(projects.filter(p => p._id !== projectToDelete._id));
//       setProjectToDelete(null);
//     } catch (error) {
//       console.error("Failed to delete project:", error);
//     } finally {
//       fetchUsage()
//     }
//   };

//   useEffect(() => {
//     fetchProjects();
//     fetchUsage()
//     fetchUser()
//   }, []);

//   // Filter Logic
//   const filteredProjects = projects.filter(project =>
//     project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//     (project.description || '').toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <div className="max-w-7xl mx-auto space-y-12">
//       <SEO title="Project Registry" description="Management interface." noIndex={true} />

//       {/* Header Section with Search */}
//       <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
//         <div className="flex-1">
//           <h1 className="text-4xl font-black text-white tracking-tighter">Your Infrastructure</h1>
//           <p className="text-gray-500 font-medium mt-1">Manage encrypted vaults across your entire stack.</p>
//         </div>

//         <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 w-full lg:w-auto">

//           {/* Search Bar - Full width on mobile, fixed width on desktop */}
//           <div className="relative group w-full lg:w-64">
//             <Search
//               className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-600 group-focus-within:text-orange-500 transition-colors"
//               size={18}
//             />
//             <input
//               type="text"
//               placeholder="Search vaults..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl pl-12 pr-4 py-2.5 lg:py-3 text-sm text-white focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none transition-all placeholder:text-gray-700"
//             />
//           </div>

//           {/* Action Area */}
//           <div className="flex-shrink-0">
//             {usage?.usage?.projectCount < usage?.limits?.projects ? (
//               <Button
//                 onClick={() => setCreateOpen(true)}
//                 variant="primary"
//                 size="sm"
//                 className="w-full lg:w-auto shrink-0 py-2.5 lg:py-3"
//               >
//                 <Plus size={18} className="mr-2" />
//                 <span>New Project</span>
//               </Button>
//             ) : (
//               /* --- Classy Upgrade Prompt: Slimmer for mobile --- */
//               <div className="flex items-center justify-between lg:justify-start gap-3 px-4 py-2 bg-[#0d0d0d] border border-orange-500/20 rounded-xl group transition-all hover:border-orange-500/40 w-full lg:w-auto">

//                 <div className="flex items-center gap-3">
//                   <div className="flex shrink-0 w-7 h-7 rounded-lg bg-orange-500/10 items-center justify-center">
//                     <Zap size={13} className="text-orange-500 animate-pulse" />
//                   </div>

//                   <div className="flex flex-col lg:flex-row lg:items-center gap-0 lg:gap-3">
//                     <p className="text-[10px] lg:text-[11px] font-bold text-gray-400 uppercase tracking-widest leading-none">
//                       Limit Reached
//                     </p>
//                     {/* Hidden on mobile, shown on desktop */}
//                     <div className="hidden lg:block w-1 h-1 rounded-full bg-gray-700" />
//                     <button
//                       onClick={() => navigate('/dashboard/subscription')}
//                       className="text-[10px] lg:text-[11px] text-orange-500 font-black uppercase tracking-tighter hover:text-orange-400 transition-colors flex items-center gap-1 mt-1 lg:mt-0"
//                     >
//                       Upgrade <ArrowRight size={12} className="hidden lg:inline" />
//                     </button>
//                   </div>
//                 </div>

//                 {/* Mobile-only Arrow (Keeps it compact) */}
//                 <ArrowRight size={14} className="text-orange-500 lg:hidden" />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Loading State */}
//       {loading && (
//         <div className="flex flex-col items-center justify-center py-40">
//           <div className="w-10 h-10 border-2 border-orange-500/20 border-t-orange-500 rounded-full animate-spin mb-4" />
//           <p className="text-[10px] font-black uppercase tracking-[0.3em] text-gray-700">Indexing Vaults...</p>
//         </div>
//       )}

//       {/* Empty State (No Projects Created) */}
//       {!loading && projects.length === 0 && (
//         <motion.div
//           initial={{ opacity: 0 }} animate={{ opacity: 1 }}
//           className="text-center py-32 bg-[#0a0a0a] border border-dashed border-white/5 rounded-[3rem]"
//         >
//           <div className="w-16 h-16 bg-white/[0.02] border border-white/5 rounded-2xl flex items-center justify-center mx-auto mb-6">
//             <Folder size={32} className="text-gray-700" />
//           </div>
//           <h3 className="text-xl font-black text-white tracking-tight">Vault is Empty</h3>
//           <p className="text-gray-500 mb-8 max-w-xs mx-auto text-sm">Create your first project to start centralizing your environment secrets.</p>
//           <Button onClick={() => setCreateOpen(true)} variant="outline" size="sm">
//             Create Project
//           </Button>
//         </motion.div>
//       )}

//       {/* Empty State (Search No Results) */}
//       {!loading && projects.length > 0 && filteredProjects.length === 0 && (
//         <div className="text-center py-20">
//           <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-500">
//             <Search size={20} />
//           </div>
//           <p className="text-gray-500">No projects found matching "<span className="text-white">{searchQuery}</span>"</p>
//           <button onClick={() => setSearchQuery('')} className="text-orange-500 text-sm mt-2 hover:underline">Clear Search</button>
//         </div>
//       )}

//       {/* Project Grid */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//         {filteredProjects.map((project, idx) => {
//           // 1. Check if user is the Owner
//           const isOwner = user?._id === project.owner;
//           // 2. Check if us er is an Admin in the members list
//           // Note: We use m.user._id because your JSON shows the user field is populated
//           const isAdmin = project.members?.some(
//             (m) => m.user?._id === user?._id && m.role === 'admin'
//           );

//           const canDelete = isAdmin;
//           return (
//             <motion.div
//               key={project._id}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: idx * 0.05 }}
//               className="group relative bg-[#0a0a0a] border border-white/5 rounded-[2rem] p-8 hover:border-orange-500/30 transition-all duration-500 flex flex-col h-full overflow-hidden"
//             >
//               {/* Background Glow */}
//               <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/5 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />

//               <div className="flex justify-between items-start mb-8 relative z-10">
//                 <div className="w-12 h-12 bg-gradient-to-br from-orange-500/10 to-red-600/10 border border-orange-500/20 rounded-xl flex items-center justify-center text-orange-500 group-hover:scale-110 transition-transform duration-500">
//                   <Layers size={22} />
//                 </div>
//                 <div className="flex flex-col items-end">
//                   <span className="text-[10px] font-black uppercase tracking-widest text-gray-700">Last Sync</span>
//                   <span className="text-xs text-gray-500 font-medium">
//                     {new Date(project.updatedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
//                   </span>
//                 </div>
//               </div>

//               <h3 className="text-2xl font-black mb-3 text-white tracking-tighter group-hover:text-orange-500 transition-colors line-clamp-2 break-words min-h-[3.5rem]">
//                 {project.name}
//               </h3>
//               <p className="text-gray-500 text-sm mb-8 flex-grow line-clamp-2 font-medium leading-relaxed">
//                 {project.description || "No description provided."}
//               </p>

//               <div className="grid grid-cols-2 gap-4 mb-8 pt-6 border-t border-white/5 relative z-10">
//                 <div className="flex items-center gap-3">
//                   <div className="w-8 h-8 rounded-full  flex items-center justify-center text-gray-500">
//                     <Users size={14} />
//                   </div>
//                   <div>
//                     <p className="text-[10px] font-black uppercase tracking-widest text-gray-700 leading-none">Collaborators</p>
//                     <p className="text-sm font-bold text-white leading-tight mt-1">{project.memberCount || 1}</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Footer Actions */}
//               <div className="mt-auto w-full flex items-center gap-3 relative z-10">
//                 <Link
//                   to={`/dashboard/projects/${project._id}`}
//                   className="
//                   flex-1 flex items-center justify-between px-6 py-4
//                   bg-white/[0.03] border border-white/5
//                   hover:bg-orange-500 hover:text-white hover:border-orange-500
//                   rounded-2xl text-sm font-black uppercase tracking-widest
//                   transition-all duration-300 group/btn
//                 "
//                 >
//                   {/* Changed Label for Responsiveness */}
//                   OPEN
//                   <ChevronRight size={18} className="group-hover/btn:translate-x-1 transition-transform" />
//                 </Link>

//                 {canDelete && <button
//                   onClick={(e) => {
//                     e.preventDefault();
//                     setProjectToDelete(project);
//                   }}
//                   className="
//                   flex items-center justify-center w-[54px] h-[54px]
//                   bg-white/[0.03] border border-white/5 rounded-2xl
//                   text-gray-500 hover:text-red-500 hover:bg-red-500/10 hover:border-red-500/30
//                   transition-all duration-300
//                 "
//                   title="Delete Project"
//                 >
//                   <Trash2 size={18} />
//                 </button>}
//               </div>
//             </motion.div>
//           )
//         })}
//       </div>

//       {/* Create Modal */}
//       <Modal isOpen={isCreateOpen} onClose={() => setCreateOpen(false)} title="New Infrastructure Vault">
//         <Formik
//           initialValues={{ name: '', description: '' }}
//           validationSchema={Yup.object({
//             name: Yup.string().required('Project name is required'),
//             description: Yup.string().max(100, 'Keep it short (max 100 chars)')
//           })}
//           onSubmit={async (values, { resetForm }) => {
//             try {
//               await projectsAPI.create(values);
//               fetchProjects();
//               setCreateOpen(false);
//               fetchUsage()
//               resetForm();
//             } catch (err) {
//               console.error("Creation failed");
//             }
//           }}
//         >
//           {({ errors, touched, isSubmitting }) => (
//             <Form className="space-y-8">
//               <div className="group">
//                 <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-3 ml-1 group-focus-within:text-orange-500 transition-colors">
//                   Project Identifier
//                 </label>
//                 <Field
//                   name="name"
//                   className="w-full bg-white/[0.03] border border-white/10 rounded-2xl px-5 py-4 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/5 outline-none transition-all placeholder:text-gray-800"
//                   placeholder="e.g. backend-api-v2"
//                 />
//                 {errors.name && touched.name && <div className="text-red-500 text-[10px] font-black uppercase mt-2 ml-1">{errors.name}</div>}
//               </div>

//               <div className="group">
//                 <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-3 ml-1 group-focus-within:text-orange-500 transition-colors">
//                   Internal Description
//                 </label>
//                 <Field
//                   as="textarea"
//                   name="description"
//                   rows="3"
//                   className="w-full bg-white/[0.03] border border-white/10 rounded-2xl px-5 py-4 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/5 outline-none transition-all placeholder:text-gray-800 resize-none"
//                   placeholder="What infrastructure does this vault manage?"
//                 />
//               </div>

//               <div className="pt-4">
//                 <Button
//                   type="submit"
//                   disabled={isSubmitting}
//                   variant="primary"
//                   className="w-full"
//                 >
//                   {isSubmitting ? "Encrypting..." : "Provision Vault"}
//                 </Button>
//               </div>
//             </Form>
//           )}
//         </Formik>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal
//         isOpen={!!projectToDelete}
//         onClose={() => setProjectToDelete(null)}
//         title="Destroy Vault?"
//         variant="danger"
//       >
//         <div className="space-y-6">
//           <div className="bg-red-500/5 border border-red-500/10 p-5 rounded-2xl flex gap-4">
//             <div className="p-3 bg-red-500/10 rounded-xl h-fit text-red-500">
//               <AlertTriangle size={20} />
//             </div>
//             <div>
//               <h4 className="text-red-500 font-bold text-sm uppercase tracking-wide mb-1">Warning: Irreversible Action</h4>
//               <p className="text-gray-400 text-xs leading-relaxed">
//                 You are about to permanently delete <span className="text-white font-bold">"{projectToDelete?.name}"</span>. This includes all keys, history, and CI tokens.
//               </p>
//             </div>
//           </div>

//           <div className="grid grid-cols-2 gap-4">
//             <Button
//               variant="outline"
//               onClick={() => setProjectToDelete(null)}
//               className="w-full"
//             >
//               Cancel
//             </Button>
//             <button
//               onClick={handleDelete}
//               className="
//                 flex items-center justify-center gap-2 w-full
//                 bg-red-600 hover:bg-red-500 text-white
//                 font-bold uppercase tracking-widest text-xs
//                 py-4 rounded-xl transition-all
//               "
//             >
//               Confirm Deletion
//             </button>
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// }

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Plus, Folder, Users, X, Layers, ChevronRight,
  Trash2, AlertTriangle, Search, Zap, ArrowRight, Lock
} from 'lucide-react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { authAPI, projectsAPI } from '../../services/api';
import Button from '../../components/ui/Button';
import SEO from '../../components/shared/SEO';
import { useAuth } from '../../context/AuthContext';

// --- Reusable Modal Component ---
const Modal = ({ isOpen, onClose, title, children, variant = 'default' }) => (
  <AnimatePresence>
    {isOpen && (
      <>
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose} className="fixed inset-0 bg-black/90 backdrop-blur-md z-[100]"
        />
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 40 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 40 }}
          className={`fixed w-full top-[20%] left-0 right-0 mx-auto max-w-lg bg-[#0a0a0a] border rounded-[2.5rem] shadow-2xl z-[101] overflow-hidden ${variant === 'danger' ? 'border-red-500/30' : 'border-white/10'
            }`}
        >
          <div className="flex justify-between items-center p-8 border-b border-white/5">
            <h3 className={`font-black text-2xl tracking-tighter ${variant === 'danger' ? 'text-red-500' : 'text-white'}`}>
              {title}
            </h3>
            <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors p-2 hover:bg-white/5 rounded-full">
              <X size={20} />
            </button>
          </div>
          <div className="p-10">{children}</div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);

export default function Projects() {
  const [isCreateOpen, setCreateOpen] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, setUser, usage, setUsage } = useAuth();
  const navigate = useNavigate();

  // New State for Search
  const [searchQuery, setSearchQuery] = useState('');

  const fetchUsage = async () => {
    const data = await authAPI.usage();
    if (data) setUsage(data);
  };

  const fetchUser = async () => {
    const data = await authAPI.getMe();
    if (data) {
      setUser(data);
    }
  };

  const fetchProjects = async () => {
    try {
      const data = await projectsAPI.getAll();
      setProjects(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!projectToDelete) return;
    try {
      await projectsAPI.deleteProject(projectToDelete._id);
      // setProjects(projects.filter(p => p._id !== projectToDelete._id));
      fetchProjects()
      setProjectToDelete(null);
    } catch (error) {
      console.error("Failed to delete project:", error);
    } finally {
      fetchUsage();
    }
  };

  useEffect(() => {
    fetchProjects();
    fetchUsage();
    fetchUser();
  }, []);

  // Filter Logic
  const filteredProjects = projects.filter(project =>
    project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (project.description || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="max-w-7xl mx-auto space-y-12">
      <SEO title="Project Registry" description="Management interface." noIndex={true} />

      {/* Header Section with Search */}
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div className="flex-1">
          <h1 className="text-4xl font-black text-white tracking-tighter">Your Infrastructure</h1>
          <p className="text-gray-500 font-medium mt-1">Manage encrypted vaults across your entire stack.</p>
        </div>

        <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 w-full lg:w-auto">

          {/* Search Bar */}
          <div className="relative group w-full lg:w-64">
            <Search
              className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-600 group-focus-within:text-orange-500 transition-colors"
              size={18}
            />
            <input
              type="text"
              placeholder="Search vaults..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-[#0a0a0a] border border-white/10 rounded-xl pl-12 pr-4 py-2.5 lg:py-3 text-sm text-white focus:border-orange-500 focus:ring-1 focus:ring-orange-500 outline-none transition-all placeholder:text-gray-700"
            />
          </div>

          {/* Action Area */}
        {!loading &&   <div className="flex-shrink-0">
            {usage?.usage?.projectCount < usage?.limits?.projects ? (
              <Button
                onClick={() => setCreateOpen(true)}
                variant="primary"
                size="sm"
                className="w-full lg:w-auto shrink-0 py-2.5 lg:py-3"
              >
                <Plus size={18} className="mr-2" />
                <span>New Project</span>
              </Button>
            ) : (
              <div className="flex items-center justify-between lg:justify-start gap-3 px-4 py-2 bg-[#0d0d0d] border border-orange-500/20 rounded-xl group transition-all hover:border-orange-500/40 w-full lg:w-auto">
                <div className="flex items-center gap-3">
                  <div className="flex shrink-0 w-7 h-7 rounded-lg bg-orange-500/10 items-center justify-center">
                    <Zap size={13} className="text-orange-500 animate-pulse" />
                  </div>
                  <div className="flex flex-col lg:flex-row lg:items-center gap-0 lg:gap-3">
                    <p className="text-[10px] lg:text-[11px] font-bold text-gray-400 uppercase tracking-widest leading-none">
                      Limit Reached
                    </p>
                    <div className="hidden lg:block w-1 h-1 rounded-full bg-gray-700" />
                    <button
                      onClick={() => navigate('/dashboard/subscription')}
                      className="text-[10px] lg:text-[11px] text-orange-500 font-black uppercase tracking-tighter hover:text-orange-400 transition-colors flex items-center gap-1 mt-1 lg:mt-0"
                    >
                      Upgrade <ArrowRight size={12} className="hidden lg:inline" />
                    </button>
                  </div>
                </div>
                <ArrowRight size={14} className="text-orange-500 lg:hidden" />
              </div>
            )}
          </div>}
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="flex flex-col items-center justify-center py-40">
          <div className="w-10 h-10 border-2 border-orange-500/20 border-t-orange-500 rounded-full animate-spin mb-4" />
          <p className="text-[10px] font-black uppercase tracking-[0.3em] text-gray-700">Indexing Vaults...</p>
        </div>
      )}

      {/* Empty State (No Projects Created) */}
      {!loading && projects.length === 0 && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          className="text-center py-32 bg-[#0a0a0a] border border-dashed border-white/5 rounded-[3rem]"
        >
          <div className="w-16 h-16 bg-white/[0.02] border border-white/5 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Folder size={32} className="text-gray-700" />
          </div>
          <h3 className="text-xl font-black text-white tracking-tight">Vault is Empty</h3>
          <p className="text-gray-500 mb-8 max-w-xs mx-auto text-sm">Create your first project to start centralizing your environment secrets.</p>
          <Button onClick={() => setCreateOpen(true)} variant="outline" size="sm">
            Create Project
          </Button>
        </motion.div>
      )}

      {/* Empty State (Search No Results) */}
      {!loading && projects.length > 0 && filteredProjects.length === 0 && (
        <div className="text-center py-20">
          <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center mx-auto mb-4 text-gray-500">
            <Search size={20} />
          </div>
          <p className="text-gray-500">No projects found matching "<span className="text-white">{searchQuery}</span>"</p>
          <button onClick={() => setSearchQuery('')} className="text-orange-500 text-sm mt-2 hover:underline">Clear Search</button>
        </div>
      )}

      {/* Project Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredProjects.map((project, idx) => {
          const isOwner = user?._id === project.owner;
          const isAdmin = project.members?.some(
            (m) => m.user?._id === user?._id && m.role === 'admin'
          );
          const canDelete = isAdmin || isOwner;
          const isLocked = project.status === 'locked';

          return (
            <motion.div
              key={project._id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.05 }}
              className={`group relative rounded-[2rem] p-8 transition-all duration-500 flex flex-col h-full overflow-hidden ${
                isLocked 
                  ? 'bg-[#0d0d0d] border border-red-500/10 opacity-90 hover:border-red-500/30' 
                  : 'bg-[#0a0a0a] border border-white/5 hover:border-orange-500/30'
              }`}
            >
              {/* Background Glow (Disabled if locked) */}
              {!isLocked && (
                <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500/5 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
              )}

              <div className="flex justify-between items-start mb-8 relative z-10">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-transform duration-500 ${
                  isLocked 
                    ? 'bg-red-500/10 border border-red-500/20 text-red-500' 
                    : 'bg-gradient-to-br from-orange-500/10 to-red-600/10 border border-orange-500/20 text-orange-500 group-hover:scale-110'
                }`}>
                  {isLocked ? <Lock size={20} /> : <Layers size={22} />}
                </div>
                <div className="flex flex-col items-end">
                  <span className="text-[10px] font-black uppercase tracking-widest text-gray-700">Last Sync</span>
                  <span className="text-xs text-gray-500 font-medium">
                    {new Date(project.updatedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
                  </span>
                </div>
              </div>

              <h3 className={`text-2xl font-black mb-3 tracking-tighter transition-colors line-clamp-2 break-words min-h-[3.5rem] ${
                isLocked ? 'text-gray-400' : 'text-white group-hover:text-orange-500'
              }`}>
                {project.name}
              </h3>
              
              {isLocked ? (
                <div className="mb-8 flex-grow">
                   <p className="text-xs font-bold uppercase tracking-widest text-red-500 bg-red-500/10 inline-block px-3 py-1.5 rounded-lg">
                    Subscription Expired
                   </p>
                </div>
              ) : (
                <p className="text-gray-500 text-sm mb-8 flex-grow line-clamp-2 font-medium leading-relaxed">
                  {project.description || "No description provided."}
                </p>
              )}

              <div className="grid grid-cols-2 gap-4 mb-8 pt-6 border-t border-white/5 relative z-10">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center text-gray-500">
                    <Users size={14} />
                  </div>
                  <div>
                    <p className="text-[10px] font-black uppercase tracking-widest text-gray-700 leading-none">Collaborators</p>
                    <p className={`text-sm font-bold leading-tight mt-1 ${isLocked ? 'text-gray-500' : 'text-white'}`}>
                      {project.memberCount || 1}
                    </p>
                  </div>
                </div>
              </div>

              {/* Footer Actions */}
              <div className="mt-auto w-full flex items-center gap-3 relative z-10">
                <Link
                  to={isLocked ? `/dashboard/subscription` : `/dashboard/projects/${project._id}`}
                  className={`
                    flex-1 flex items-center justify-between px-6 py-4
                    rounded-2xl text-sm font-black uppercase tracking-widest
                    transition-all duration-300 group/btn
                    ${isLocked 
                      ? 'bg-red-500/5 text-red-500 border border-red-500/20 hover:bg-red-500 hover:text-white hover:border-red-500' 
                      : 'bg-white/[0.03] text-white border border-white/5 hover:bg-orange-500 hover:text-white hover:border-orange-500'
                    }
                  `}
                >
                  {isLocked ? 'UNLOCK VAULT' : 'OPEN'}
                  <ChevronRight size={18} className="group-hover/btn:translate-x-1 transition-transform" />
                </Link>

                {canDelete && (
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setProjectToDelete(project);
                    }}
                    className={`
                      flex items-center justify-center w-[54px] h-[54px]
                      bg-white/[0.03] border border-white/5 rounded-2xl
                      transition-all duration-300
                      ${isLocked 
                        ? 'text-gray-600 hover:text-red-500 hover:bg-red-500/10' 
                        : 'text-gray-500 hover:text-red-500 hover:bg-red-500/10 hover:border-red-500/30'
                      }
                    `}
                    title="Delete Project"
                  >
                    <Trash2 size={18} />
                  </button>
                )}
              </div>
            </motion.div>
          )
        })}
      </div>

      {/* Create Modal */}
      <Modal isOpen={isCreateOpen} onClose={() => setCreateOpen(false)} title="New Infrastructure Vault">
        {/* ... (Create Modal Form code remains the exact same) ... */}
        <Formik
          initialValues={{ name: '', description: '' }}
          validationSchema={Yup.object({
            name: Yup.string().required('Project name is required'),
            description: Yup.string().max(100, 'Keep it short (max 100 chars)')
          })}
          onSubmit={async (values, { resetForm }) => {
            try {
              await projectsAPI.create(values);
              fetchProjects();
              setCreateOpen(false);
              fetchUsage()
              resetForm();
            } catch (err) {
              console.error("Creation failed");
            }
          }}
        >
          {({ errors, touched, isSubmitting }) => (
            <Form className="space-y-8">
              <div className="group">
                <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-3 ml-1 group-focus-within:text-orange-500 transition-colors">
                  Project Identifier
                </label>
                <Field
                  name="name"
                  className="w-full bg-white/[0.03] border border-white/10 rounded-2xl px-5 py-4 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/5 outline-none transition-all placeholder:text-gray-800"
                  placeholder="e.g. backend-api-v2"
                />
                {errors.name && touched.name && <div className="text-red-500 text-[10px] font-black uppercase mt-2 ml-1">{errors.name}</div>}
              </div>

              <div className="group">
                <label className="block text-[10px] font-black uppercase tracking-[0.2em] text-gray-500 mb-3 ml-1 group-focus-within:text-orange-500 transition-colors">
                  Internal Description
                </label>
                <Field
                  as="textarea"
                  name="description"
                  rows="3"
                  className="w-full bg-white/[0.03] border border-white/10 rounded-2xl px-5 py-4 text-sm text-white focus:border-orange-500 focus:ring-4 focus:ring-orange-500/5 outline-none transition-all placeholder:text-gray-800 resize-none"
                  placeholder="What infrastructure does this vault manage?"
                />
              </div>

              <div className="pt-4">
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  variant="primary"
                  className="w-full"
                >
                  {isSubmitting ? "Encrypting..." : "Provision Vault"}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={!!projectToDelete}
        onClose={() => setProjectToDelete(null)}
        title="Destroy Vault?"
        variant="danger"
      >
        <div className="space-y-6">
          <div className="bg-red-500/5 border border-red-500/10 p-5 rounded-2xl flex gap-4">
            <div className="p-3 bg-red-500/10 rounded-xl h-fit text-red-500">
              <AlertTriangle size={20} />
            </div>
            <div>
              <h4 className="text-red-500 font-bold text-sm uppercase tracking-wide mb-1">Warning: Irreversible Action</h4>
              <p className="text-gray-400 text-xs leading-relaxed">
                You are about to permanently delete <span className="text-white font-bold">"{projectToDelete?.name}"</span>. This includes all keys, history, and CI tokens.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <Button
              variant="outline"
              onClick={() => setProjectToDelete(null)}
              className="w-full"
            >
              Cancel
            </Button>
            <button
              onClick={handleDelete}
              className="
                flex items-center justify-center gap-2 w-full
                bg-red-600 hover:bg-red-500 text-white
                font-bold uppercase tracking-widest text-xs
                py-4 rounded-xl transition-all
              "
            >
              Confirm Deletion
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}